"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/AssetLibrary/Types");
var ImageLibraryDataStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryDataStore");
var ImageLibraryUtils_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryUtils");
var Types_2 = require("Common/AssetLibrary/ImageLibrary/Types");
var Upload_1 = require("Common/Upload");
var UploadUtils_1 = __importDefault(require("Common/Upload/UploadUtils"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var range_1 = __importDefault(require("lodash/range"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var react_1 = __importDefault(require("react"));
var DraggableImageCard_1 = __importDefault(require("./DraggableImageCard"));
var LoadingImageCard_1 = __importDefault(require("./LoadingImageCard"));
var UnsplashCollection_1 = __importDefault(require("./UnsplashCollection"));
var ImageFetchingErrorMessage_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageFetchingErrorMessage/ImageFetchingErrorMessage");
var ImageFetchingErrorMessageUtils_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageFetchingErrorMessage/ImageFetchingErrorMessageUtils");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var BetterInfiniteScroll_1 = require("./BetterInfiniteScroll/BetterInfiniteScroll");
var ImageCdnHelper_1 = require("@CommonFrontendBackend/Utils/ImageCdnHelper");
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var DisplayMode;
(function (DisplayMode) {
    DisplayMode["Collections"] = "collections";
    DisplayMode["Images"] = "images";
    DisplayMode["ErrorMessage"] = "error message";
})(DisplayMode || (DisplayMode = {}));
var BASE_CLASS_NAME = "image-library-tab";
var ImageLibraryTab = (function (_super) {
    __extends(ImageLibraryTab, _super);
    function ImageLibraryTab(props) {
        var _this = _super.call(this, props) || this;
        _this.handleImageCardClick = function (image) {
            _this.props.clickToAddImageStore.clickToAdd({
                mediaData: {
                    id: image.id,
                    url: image.url,
                    thumbnailUrl: image.thumbnailUrl,
                    altDescription: image.altDescription,
                },
                mediaSource: image.mediaSource,
                telemetryData: _this.telemetryData,
            });
            _this.props.contentSidebarViewStore.hideFolders();
        };
        _this.onUpload = function () {
            var _a = _this.props, sidebarImageViewStore = _a.sidebarImageViewStore, uploadStore = _a.uploadStore, duplicateUploadNotifier = _a.duplicateUploadNotifier;
            if (!_this.fileInputRef.current || !_this.fileInputRef.current.files) {
                return;
            }
            var file = _this.fileInputRef.current.files[0];
            if (!file) {
                return;
            }
            if (!(0, ImageLibraryUtils_1.isAnUploadsFolder)(_this.currentFolder)) {
                sidebarImageViewStore.selectFolder(Types_2.ImageLibrarySystemFolder.Uploads);
            }
            var uploadFolderId = (0, ImageLibraryUtils_1.toApiFolderId)(_this.currentFolder);
            var uploadId = uploadStore.upload(file, { folderId: uploadFolderId });
            duplicateUploadNotifier.notifyOnDuplicateUpload(uploadId);
            sidebarImageViewStore.addUploadId(uploadId);
        };
        _this.gridContainerRef = react_1.default.createRef();
        _this.contentWrapperRef = react_1.default.createRef();
        _this.fileInputRef = react_1.default.createRef();
        _this.imageLibraryDataStore = _this.props.imageLibraryDataStore;
        return _this;
    }
    ImageLibraryTab.prototype.componentWillUnmount = function () {
        this.props.sidebarImageViewStore.clear();
    };
    ImageLibraryTab.prototype.startDragging = function (event, image) {
        event.dataTransfer.effectAllowed = "copy";
        var _a = this.props, dragStore = _a.dragStore, contentSidebarViewStore = _a.contentSidebarViewStore;
        event.dataTransfer.setData("text/uri-list", image.url);
        dragStore.startDrag({
            type: DragStore_1.DragType.SidebarImage,
            mediaData: {
                id: image.id,
                url: image.url,
                thumbnailUrl: image.thumbnailUrl,
                altDescription: image.altDescription,
            },
            mediaSource: image.mediaSource,
            telemetryData: this.telemetryData,
        });
        contentSidebarViewStore.hideFolders();
    };
    ImageLibraryTab.prototype.stopDragging = function () {
        this.props.dragStore.stopDrag();
        this.props.dropLocationStore.clearDropLocation();
    };
    Object.defineProperty(ImageLibraryTab.prototype, "normalisedImages", {
        get: function () {
            var _this = this;
            var assets = this.imageLibraryDataStore.assets;
            return assets.map(function (asset) {
                var name;
                var mediaSource;
                if ((0, ImageLibraryUtils_1.isRecentlyUsedImage)(asset)) {
                    mediaSource = asset.mediaSource;
                }
                else if ((0, ImageLibraryUtils_1.isUploadedImage)(asset)) {
                    name = asset.name;
                    mediaSource = Types_1.MediaSource.UploadedImage;
                }
                else if (_this.props.sidebarImageViewStore.isShowingQwilrStockImages) {
                    mediaSource = Types_1.MediaSource.StockImages;
                }
                else {
                    mediaSource = Types_1.MediaSource.Unsplash;
                }
                var url = asset.url || asset.thumbnailUrl;
                var altDescription = asset.altDescription;
                return __assign(__assign({}, asset), { name: name, url: url, mediaSource: mediaSource, altDescription: altDescription });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "currentUploads", {
        get: function () {
            if (!(0, ImageLibraryUtils_1.isAnUploadsFolder)(this.currentFolder)) {
                return [];
            }
            var sidebarImageViewStore = this.props.sidebarImageViewStore;
            var currentFolderApiId = (0, ImageLibraryUtils_1.toApiFolderId)(this.currentFolder);
            return (0, uniqBy_1.default)(this.props.uploadStore.getAllUploadsProgress().filter(function (upload) {
                return (UploadUtils_1.default.isImage(upload.file) &&
                    upload.folderId === currentFolderApiId &&
                    sidebarImageViewStore.shouldRenderUploadId(upload.id));
            }), function (currentUpload) { return currentUpload.dataUrl; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "completedUploadIds", {
        get: function () {
            return this.currentUploads
                .filter(function (uploads) { return uploads.state === Upload_1.UploadState.Success || uploads.state === Upload_1.UploadState.Error; })
                .map(function (upload) { var _a; return (_a = upload === null || upload === void 0 ? void 0 : upload.uploadResponse) === null || _a === void 0 ? void 0 : _a.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "searchProperties", {
        get: function () {
            var currentFolder = this.currentFolder;
            if (currentFolder === Types_2.ImageLibrarySystemFolder.RecentlyUsed) {
                return { visible: false };
            }
            if (this.props.sidebarImageViewStore.isShowingQwilrStockImages &&
                currentFolder === Types_2.ImageLibrarySystemFolder.Unsplash) {
                return {
                    visible: false,
                };
            }
            if (this.displayMode === DisplayMode.ErrorMessage) {
                return {
                    visible: false,
                };
            }
            return { visible: true, label: this.searchPlaceholderText };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "searchPlaceholderText", {
        get: function () {
            var currentFolder = this.currentFolder;
            if (currentFolder === Types_2.ImageLibrarySystemFolder.Unsplash) {
                return "Search Unsplash images";
            }
            else if (currentFolder === Types_2.ImageLibrarySystemFolder.Uploads || (0, ImageLibraryUtils_1.isCustomFolder)(currentFolder)) {
                return "Search all uploads";
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "isLoadingFirstPage", {
        get: function () {
            if (this.imageLibraryDataStore.isOutOfNewData) {
                return false;
            }
            if (this.displayMode === DisplayMode.ErrorMessage) {
                return false;
            }
            if (!this.isNextPageLoading) {
                return false;
            }
            if (this.displayMode === DisplayMode.Collections) {
                return this.imageLibraryDataStore.collections.length === 0;
            }
            else {
                return this.normalisedImages.length === 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "isEmpty", {
        get: function () {
            if (!this.imageLibraryDataStore.isOutOfNewData) {
                return false;
            }
            if (this.displayMode === DisplayMode.Collections) {
                return this.imageLibraryDataStore.collections.length === 0;
            }
            else if ((0, ImageLibraryUtils_1.isAnUploadsFolder)(this.currentFolder)) {
                return this.normalisedImages.length === 0 && this.currentUploads.length === 0;
            }
            else {
                return this.normalisedImages.length === 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "hasNoUploads", {
        get: function () {
            return ((0, ImageLibraryUtils_1.isAnUploadsFolder)(this.currentFolder) &&
                this.normalisedImages.length === 0 &&
                this.currentUploads.length === 0 &&
                this.imageLibraryDataStore.isOutOfNewData &&
                !this.searchString);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "searchString", {
        get: function () {
            return this.props.sidebarImageViewStore.searchString;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "currentFolder", {
        get: function () {
            return this.props.sidebarImageViewStore.currentFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "isNextPageLoading", {
        get: function () {
            return this.props.sidebarImageViewStore.isNextPageLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageLibraryTab.prototype, "displayMode", {
        get: function () {
            var sidebarImageViewStore = this.props.sidebarImageViewStore;
            if (sidebarImageViewStore.errorOccurredWhileFetchingContent) {
                return DisplayMode.ErrorMessage;
            }
            if (sidebarImageViewStore.currentFolder === Types_2.ImageLibrarySystemFolder.Unsplash &&
                sidebarImageViewStore.currentUnsplashCollectionId === undefined &&
                sidebarImageViewStore.searchString === "" &&
                !sidebarImageViewStore.isShowingQwilrStockImages) {
                return DisplayMode.Collections;
            }
            return DisplayMode.Images;
        },
        enumerable: false,
        configurable: true
    });
    ImageLibraryTab.prototype.renderOutOfImagesMessage = function () {
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__out-of-images") },
            react_1.default.createElement("p", null, "All images loaded!")));
    };
    ImageLibraryTab.prototype.renderUploadsSection = function () {
        var _this = this;
        if (this.currentUploads.length > 0) {
            return this.currentUploads
                .slice()
                .reverse()
                .map(function (currentUpload) {
                if (currentUpload.state !== Upload_1.UploadState.Success) {
                    return (react_1.default.createElement(LoadingImageCard_1.default, { key: currentUpload.id, uploadProgress: currentUpload, onRetry: _this.props.uploadStore.retry }));
                }
                else if (currentUpload.state === Upload_1.UploadState.Success && !!currentUpload.uploadResponse) {
                    var image_1 = completedUploadProgressToImageMapper(currentUpload, _this.props.disableImgix);
                    return (react_1.default.createElement(DraggableImageCard_1.default, { key: image_1.id, image: { thumbnailUrl: image_1.url, name: image_1.name }, onClick: function () { return _this.handleImageCardClick(image_1); }, onDragStart: function (event) { return _this.startDragging(event, image_1); }, onDragEnd: function () { return _this.stopDragging(); } }));
                }
            });
        }
    };
    ImageLibraryTab.prototype.renderErrorMessage = function () {
        var sidebarImageViewStore = this.props.sidebarImageViewStore;
        var errorMessage = (0, ImageFetchingErrorMessageUtils_1.getImageFetchingErrorMessage)(sidebarImageViewStore.currentFolder, sidebarImageViewStore.showQwilrStockImages);
        if (!errorMessage) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__error-message") },
            react_1.default.createElement(ImageFetchingErrorMessage_1.ImageFetchingErrorMessage, __assign({}, errorMessage))));
    };
    Object.defineProperty(ImageLibraryTab.prototype, "telemetryData", {
        get: function () {
            var _a;
            var assetFolderType = (_a = {},
                _a[Types_2.ImageLibrarySystemFolder.Uploads] = TelemetryParameterValue_1.AssetFolderType.Uploads,
                _a[Types_2.ImageLibrarySystemFolder.RecentlyUsed] = TelemetryParameterValue_1.AssetFolderType.RecentlyUsed,
                _a[Types_2.ImageLibrarySystemFolder.Unsplash] = TelemetryParameterValue_1.AssetFolderType.Unsplash,
                _a)[this.props.sidebarImageViewStore.currentFolder] || "";
            return {
                originWasFiltered: !!this.searchString,
                assetFolderType: !!assetFolderType ? assetFolderType : undefined,
            };
        },
        enumerable: false,
        configurable: true
    });
    ImageLibraryTab.prototype.render = function () {
        var _this = this;
        var _a = this, displayMode = _a.displayMode, searchProperties = _a.searchProperties;
        var _b = this.props, sidebarImageViewStore = _b.sidebarImageViewStore, contentSidebarViewStore = _b.contentSidebarViewStore;
        var showBackButton = displayMode === DisplayMode.Images &&
            this.currentFolder === Types_2.ImageLibrarySystemFolder.Unsplash &&
            this.searchString === "" &&
            !sidebarImageViewStore.isShowingQwilrStockImages;
        var dataLength = displayMode === DisplayMode.Collections
            ? this.imageLibraryDataStore.collections.length
            : this.normalisedImages.length;
        var showUploads = (0, ImageLibraryUtils_1.isAnUploadsFolder)(this.currentFolder) && this.searchString === "";
        var finalImages = showUploads
            ? this.normalisedImages.filter(function (asset) { return !_this.completedUploadIds.includes(asset.id); })
            : this.normalisedImages;
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__header") },
                showBackButton && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(BASE_CLASS_NAME, "__back-button"), icon: react_1.default.createElement(icons_1.ArrowLeft, null), tooltip: { content: "Back to collections" }, onClick: function () { return sidebarImageViewStore.deselectUnsplashCollection(); } })),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__folder-picker") },
                    react_1.default.createElement(kaleidoscope_3.FolderComponent, { selected: true, name: sidebarImageViewStore.currentFolderTitle, icon: sidebarImageViewStore.currentFolderIcon, onClick: contentSidebarViewStore.toggleFolderTree })),
                react_1.default.createElement(kaleidoscope_1.Button, { isIconOnly: true, as: "label", type: kaleidoscope_1.ButtonType.Tertiary, onKeyDown: function (event) {
                        if (event.key === "Enter" || event.key === " ") {
                            _this.fileInputRef.current.click();
                        }
                    }, tabIndex: 0, className: "".concat(BASE_CLASS_NAME, "__upload-button"), "aria-label": "Upload image" },
                    react_1.default.createElement(icons_1.Upload, null),
                    react_1.default.createElement("input", { type: "file", className: "".concat(BASE_CLASS_NAME, "__upload-input"), ref: this.fileInputRef, accept: "image/*", onChange: this.onUpload, tabIndex: -1 }))),
            searchProperties.visible && (react_1.default.createElement(kaleidoscope_1.SearchInput, { className: "".concat(BASE_CLASS_NAME, "__search"), label: searchProperties.label, placeholder: searchProperties.label, value: this.searchString, onClear: function () { return sidebarImageViewStore.handleSearchStringChange(""); }, onChange: function (value) { return sidebarImageViewStore.handleSearchStringChange(value); } })),
            this.isEmpty && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.EmptyState, { title: "There's nothing here!", subtitle: this.hasNoUploads ? "You haven't uploaded any images yet." : "We couldn't find any images that match.", className: "".concat(BASE_CLASS_NAME, "__empty-state") }),
                this.hasNoUploads && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__empty-state-buttons") },
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: function () {
                            _this.fileInputRef.current.click();
                        } }, "Upload an image"),
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                            _this.props.sidebarImageViewStore.selectFolder(Types_2.ImageLibrarySystemFolder.Unsplash);
                        } }, "Browse Unsplash images"))))),
            displayMode === DisplayMode.ErrorMessage ? (this.renderErrorMessage()) : (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__grid-container"), id: "".concat(BASE_CLASS_NAME, "__grid-container"), ref: this.gridContainerRef, style: { visibility: !this.isEmpty ? "visible" : "hidden" } },
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__content-wrapper"), ref: this.contentWrapperRef },
                    react_1.default.createElement(BetterInfiniteScroll_1.BetterInfiniteScroll, { next: sidebarImageViewStore.loadNextPage, hasMore: !this.imageLibraryDataStore.isOutOfNewData, loader: this.isNextPageLoading && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__grid-spinner-wrapper") },
                            react_1.default.createElement(kaleidoscope_1.Spinner, null))), dataLength: dataLength, scrollableTarget: "".concat(BASE_CLASS_NAME, "__grid-container"), style: { overflow: "initial" }, endMessage: this.renderOutOfImagesMessage(), pauseDataFetching: sidebarImageViewStore.isEnteringSearchTerm },
                        displayMode === DisplayMode.Collections && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__grid ").concat(BASE_CLASS_NAME, "__grid--collections") }, this.imageLibraryDataStore.collections.map(function (collection) { return (react_1.default.createElement(UnsplashCollection_1.default, { key: collection.collectionId, collection: collection, onClick: function () { return sidebarImageViewStore.selectUnsplashCollection(collection); } })); }))),
                        displayMode === DisplayMode.Images && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__grid ").concat(BASE_CLASS_NAME, "__grid--images") },
                            showUploads && this.renderUploadsSection(),
                            finalImages.map(function (image) { return (react_1.default.createElement(DraggableImageCard_1.default, { key: image.id, image: image, onClick: function () { return _this.handleImageCardClick(image); }, onDragStart: function (event) { return _this.startDragging(event, image); }, onDragEnd: function () { return _this.stopDragging(); } })); }))),
                        this.isLoadingFirstPage && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__grid ").concat(BASE_CLASS_NAME, "__grid--ghost") }, (0, range_1.default)(ImageLibraryDataStore_1.IMAGES_PER_PAGE).map(function (key) { return (react_1.default.createElement(kaleidoscope_1.Card, { key: key, className: "".concat(BASE_CLASS_NAME, "__card--ghost") },
                            react_1.default.createElement(kaleidoscope_2.GhostBlock, null))); })))))))));
    };
    var _a;
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _a : Object, Object]),
        __metadata("design:returntype", void 0)
    ], ImageLibraryTab.prototype, "startDragging", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ImageLibraryTab.prototype, "stopDragging", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "normalisedImages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageLibraryTab.prototype, "handleImageCardClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "currentUploads", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "completedUploadIds", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "searchProperties", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "searchPlaceholderText", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "isLoadingFirstPage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "isEmpty", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "hasNoUploads", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "searchString", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "currentFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "isNextPageLoading", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ImageLibraryTab.prototype, "displayMode", null);
    ImageLibraryTab = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageLibraryTab);
    return ImageLibraryTab;
}(react_1.default.Component));
exports.default = ImageLibraryTab;
var completedUploadProgressToImageMapper = function (upload, disableImgix) {
    if (upload.state !== Upload_1.UploadState.Success) {
        throw new Error("Only completed uploads can be converted into images");
    }
    var thumbnailUrl = (0, ImageCdnHelper_1.getImageSrc)(upload.uploadResponse.url, disableImgix);
    return __assign(__assign({}, upload.uploadResponse), { thumbnailUrl: thumbnailUrl, mediaSource: Types_1.MediaSource.UploadedImage });
};
